<template>
  <div class="text-center">
    <h2 class="mb-4">Sorry, we can't find that page.</h2>
    <p class="lead">It may have been moved, or the URL is incorrect.</p>
  </div>
</template>
